import { WButton } from "@/components/button/WButton.tsx";
import { FieldButtonGroup } from "@/components/forms/FieldButtonGroup.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { addResourceToFirewallMutation, type FirewallWithType } from "@/modules/network/firewall/firewallApi.ts";
import { FirewallSelect } from "@/modules/network/firewall/FirewallSelect.tsx";
import { Trans } from "@lingui/react/macro";
import { useState } from "react";

export interface AddFirewallFormProps {
    vmUuid: string;
    location: string;
    onClose: () => void;
}

export function AddFirewallForm({ vmUuid, location, onClose }: AddFirewallFormProps) {
    const addMutation = useStandardMutation(addResourceToFirewallMutation);
    const [target, setTarget] = useState<FirewallWithType>();

    async function onSubmit() {
        if (!target) {
            return;
        }
        await addMutation.mutateAsync({
            location,
            uuid: target.uuid,
            vm_uuid: vmUuid,
        });
        onClose();
    }

    function onChangeTarget(firewall: FirewallWithType) {
        setTarget(firewall);
    }

    return (
        <FieldButtonGroup>
            <FirewallSelect defaultOpen={true} location={location} vmUuid={vmUuid} onChange={onChangeTarget} />
            <WButton color="primary" icon="jp-icon-add" action={onSubmit}>
                <Trans>Add</Trans>
            </WButton>
            <WButton action={onClose}>
                <Trans>Close</Trans>
            </WButton>
        </FieldButtonGroup>
    );
}
